const commentsMasonry = () => {
  const firstCol = document.querySelector(".js-masonry-col-1");

  const secondCol = document.querySelector(".js-masonry-col-2");
  const thirdCol = document.querySelector(".js-masonry-col-3");

  if (!firstCol || !secondCol || !thirdCol) {
    return;
  }

  const thirdColItem = thirdCol.querySelectorAll(".js-masonry-item");

  window.addEventListener("resize", () => {
    if (window.innerWidth < 1280 && window.innerWidth > 767) {
      resizeFourth();
    } else if (window.innerWidth > 1279) {
      resizeFourthBack();
    }
  });

  const resizeFourth = () => {
    let counter = 0;
    thirdColItem.forEach((item) => {
      if (counter == 0) {
        firstCol.appendChild(item);
        counter++;
      } else if (counter == 1) {
        secondCol.appendChild(item);
        counter = 0;
      }
    });
  };

  const resizeFourthBack = () => {
    thirdColItem.forEach((item) => {
      thirdCol.appendChild(item);
    });
  };

  if (window.innerWidth < 1280 && window.innerWidth > 767) {
    resizeFourth();
  } else if (window.innerWidth > 1279) {
    resizeFourthBack();
  }
};

export default commentsMasonry;
